"use client";

import { useEffect } from "react";
import Clarity from "@microsoft/clarity";

export function MicrosoftClarity({ projectId }: { projectId: string }) {
    useEffect(() => {
        Clarity.init(projectId);
    }, [projectId]);

    return null;
}
